// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.7
//   protoc               v5.29.6
// source: email.proto

export const protobufPackage = 'compasspb';

/**
 * EmailStatus represents the current state of an email in its lifecycle.
 * Emails progress through various states from creation to final delivery or failure.
 */
export enum EmailStatus {
  /** EMAIL_STATUS_UNSPECIFIED - Default/unknown status */
  EMAIL_STATUS_UNSPECIFIED = 0,
  /** EMAIL_STATUS_IN_DRAFT - Email saved as draft, not sent */
  EMAIL_STATUS_IN_DRAFT = 1,
  /** EMAIL_STATUS_SCHEDULED - Email scheduled for future delivery */
  EMAIL_STATUS_SCHEDULED = 2,
  /** EMAIL_STATUS_IN_PROGRESS - Email is being sent via provider */
  EMAIL_STATUS_IN_PROGRESS = 3,
  /** EMAIL_STATUS_SENT - Email sent to provider */
  EMAIL_STATUS_SENT = 4,
  /** EMAIL_STATUS_DELIVERED - Email successfully delivered */
  EMAIL_STATUS_DELIVERED = 5,
  /** EMAIL_STATUS_FAILED - Email delivery failed */
  EMAIL_STATUS_FAILED = 6,
}

/**
 * Email represents an email message entity.
 * Contains all information about an email including sender, recipients,
 * content, delivery status, and timestamps.
 */
export interface Email {
  id?: string | undefined;
  from_address?: string | undefined;
  to_addresses?: string[] | undefined;
  cc?: string[] | undefined;
  bcc?: string[] | undefined;
  subject?: string | undefined;
  body?: string | undefined;
  references?: string[] | undefined;
  case_id?: string | undefined;
  message_id?: string | undefined;
  parent_id?: string | undefined;
  direction?: string | undefined;
  status?: EmailStatus | undefined;
  provider?: string | undefined;
  provider_message_id?: string | undefined;
  attachment_ids?: string[] | undefined;
  delivered_at?: string | undefined;
  error?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
}

/** CreateEmailRequest contains parameters for creating a new email. */
export interface CreateEmailRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_id?: string | undefined;
  from_address?: string | undefined;
  to_addresses?: string[] | undefined;
  cc?: string[] | undefined;
  bcc?: string[] | undefined;
  subject?: string | undefined;
  body?: string | undefined;
  references?: string[] | undefined;
  parent_id?: string | undefined;
  attachment_ids?: string[] | undefined;
}

/**
 * CreateEmailResponse returns the newly created email.
 * Contains the complete email entity with generated ID and timestamps.
 */
export interface CreateEmailResponse {
  email?: Email | undefined;
}

/** GetEmailRequest contains parameters for retrieving a single email. */
export interface GetEmailRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_id?: string | undefined;
  id?: string | undefined;
}

/**
 * GetEmailResponse returns the requested email.
 * Contains the complete email entity with all fields.
 */
export interface GetEmailResponse {
  email?: Email | undefined;
}

/**
 * ListEmailsByCaseIDRequest contains parameters for retrieving all emails for a case.
 * Supports pagination through the limit parameter.
 */
export interface ListEmailsByCaseIDRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_id?: string | undefined;
  limit?: number | undefined;
}

/**
 * ListEmailsByCaseIDResponse returns a list of emails for the case record.
 * Emails are ordered by creation time (newest first).
 */
export interface ListEmailsByCaseIDResponse {
  emails?: Email[] | undefined;
}

/**
 * UpdateEmailRequest contains parameters for updating an existing email.
 * All fields except id, organization_id, program_id, and case_id are optional.
 * Only provided fields will be updated.
 */
export interface UpdateEmailRequest {
  organization_id?: string | undefined;
  program_id?: string | undefined;
  case_id?: string | undefined;
  id?: string | undefined;
  from_address?: string | undefined;
  to_addresses?: string[] | undefined;
  cc?: string[] | undefined;
  bcc?: string[] | undefined;
  subject?: string | undefined;
  body?: string | undefined;
}

/**
 * UpdateEmailResponse returns the updated email.
 * Contains the complete email entity with all current values.
 */
export interface UpdateEmailResponse {
  email?: Email | undefined;
}

/**
 * EmailService provides operations for email communication.
 * This service handles sending and receiving emails as part of
 * case record workflows and patient/member communication. It supports
 * creating, updating, retrieving, and listing emails associated
 * with case records.
 */
export interface EmailService {
  /**
   * CreateEmail creates a new email for a case record.
   * The email is sent via the configured email provider.
   */
  createEmail(request: CreateEmailRequest): Promise<CreateEmailResponse>;
  /**
   * GetEmail retrieves a single email by its ID.
   * Returns the complete email details including status and timestamps.
   */
  getEmail(request: GetEmailRequest): Promise<GetEmailResponse>;
  /**
   * ListEmailsByCaseID retrieves all emails for a case record.
   * Returns a list of emails ordered by creation time.
   */
  listEmailsByCaseId(request: ListEmailsByCaseIDRequest): Promise<ListEmailsByCaseIDResponse>;
  /**
   * UpdateEmail updates an existing email.
   * This allows modifying email content, status, and provider information.
   */
  updateEmail(request: UpdateEmailRequest): Promise<UpdateEmailResponse>;
}
